<template>
  <!-- width="600px" 或者  width="60%"   -->
  <el-dialog
    :close-on-click-modal="false"
    title="收款"
    :show-close="true"
    :visible="true"
    :before-close="handleBeforeClose"
    width="625px"
  >
    <div class="dialog__container">
      <el-button
        size="mini"
        type="primary"
        @click="addPlan"
        class="plr28"
        style="margin-bottom: 20px"
        >添加收款</el-button
      >
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="receiptTime" label="收款时间" width="100">
        </el-table-column>
        <el-table-column
          prop="receiptAmount"
          align="right"
          header-align="right"
          label="收款金额"
          width="100"
        >
          <template slot-scope="scope">{{
            scope.row.receiptAmount | separator
          }}</template>
        </el-table-column>
        <el-table-column
          prop="receiptMethod"
          label="收款方式"
          width="100"
          :formatter="receiptMethodFormatter"
        >
        </el-table-column>
        <el-table-column
          prop="needInvoice"
          label="是否开票"
          width="100"
          :formatter="needInvoiceFormatter"
        >
        </el-table-column>
        <el-table-column prop="receiptEmployeeName" width="100" label="收款人">
        </el-table-column>
        <el-table-column label="操作" width="98px" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <div class="btn-divide"></div>
            <el-button size="mini" type="text" @click="handleDelete(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button
        class="plr28"
        size="mini"
        type="info"
        plain
        @click="handleCancel"
        >取消</el-button
      >
      <el-button class="plr28" type="primary" size="mini" @click="handleConfirm"
        >确定</el-button
      >
    </span>
    <add-dialog
      v-if="showAdd"
      @cancel="showAdd = false"
      @confirm="confirm"
      :editData="detail"
    ></add-dialog>
  </el-dialog>
</template>

<script>
import { realList, deleteContractCollection } from "@/api/ContractReceivables";
import AddDialog from "./addDialog.vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      showAdd: false,
      tableData: [],
      detail: {},
    };
  },
  components: {
    AddDialog,
  },
  props: {
    editData: {
      required: true,
    },
  },
  created() {
    this.detail = { ...this.editData };
    this.realList();
  },
  computed: {
    ...mapState("common/dictionary", ["zffsDicts"]),
  },
  methods: {
    async realList() {
      const params = {
        contractNumber: this.editData.contractNumber,
        planId: this.editData.id,
      };
      const res = await realList(params);
      if (res.code === 200) {
        this.tableData = res.data;
      }
    },
    handleBeforeClose(done) {
      this.$emit("cancel");
      done();
    },
    handleCancel() {
      this.$emit("cancel");
    },
    async handleConfirm() {
      this.$emit("confirm");
    },
    addPlan() {
      this.showAdd = true;
    },
    confirm() {
      this.showAdd = false;
      this.realList();
    },
    async handleDelete(row) {
      this.$confirm("确定删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          const res = await deleteContractCollection({ idList: [row.id] });
          if (res.code === 200) {
            this.$message.success("删除成功");
            this.realList();
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleEdit(row) {
      this.detail = { ...row };
      this.detail = { ...this.editData, ...row}
      this.detail.receiptMethod = this.detail.receiptMethod.toString()
      this.showAdd = true;
    },
    receiptMethodFormatter(row) {
      let str = "";
      this.zffsDicts.some((item) => {
        if (item.dictionaryCode == row.receiptMethod) {
          str = item.dictionaryValue;
          return true;
        }
      });
      return str;
    },
    needInvoiceFormatter(row) {
      if (row.needInvoice == 0) {
        return "否";
      }
      if (row.needInvoice == 1) {
        return "是";
      }
      return "";
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/ContractReceivables/components/checkDialog.vue